import { Button } from "@climatepartner/components/Button";
import { ErrorPage } from "@climatepartner/components/ErrorPages";
import SentimentDissatisfiedOutlined from "@mui/icons-material/SentimentDissatisfiedOutlined";
import Typography from "@mui/material/Typography";
import { ReactElement } from "react";
import { useNavigate } from "react-router-dom";

interface Props {
  error?: Error;
  errorAction?: ReactElement;
}

export const OrganisationUnusableErrorPage = ({ error }: Props): ReactElement => {
  const navigate = useNavigate();
  const navigateBack = (): void => {
    navigate(-1);
  };
  return (
    <ErrorPage
      title={""}
      subtitle={"Can not access organisation"}
      icon={<SentimentDissatisfiedOutlined />}
      error={error}
    >
      <Typography component="p">
        <p>Please make sure the organisation has access to CFC and is active</p>
      </Typography>

      <Button variant="outlined" onClick={navigateBack}>
        Back
      </Button>
    </ErrorPage>
  );
};
